// extracted by mini-css-extract-plugin
export default {"content":"criteria-warning-modal_content__gBzRW","buttons":"criteria-warning-modal_buttons__p3awo"};